import { useQuery } from "@apollo/client";
import { FC, useEffect, useState } from "react";
import { GET_CARS, GET_RENTALS } from "../../apollo/operations";
import { useSelector } from "react-redux";
import { RentalType, VehicleType } from "../../types";
import { HostDriver } from "../../assets/images";
import { Link, useNavigate } from "react-router-dom";
import { HostCars, ListedCard, Loading, EditVehicle } from "../../components";
import { BsChatText } from "react-icons/bs";
import { RootState } from "../../redux/store";
import EditPlan from "../../components/host/EditPlan";

const Host: FC = () => {
  const [lessorVehicles, setLessorVehicles] = useState<VehicleType[]>([]);

  const headers: string[] = [
    "Active Vehicles",
    "Booked Vehicles",
    "All Vehicles",
  ];

  const [activeHeader, setActiveHeader] = useState<string>(headers[2]);
  const [activeVehicles, setActiveVehicles] = useState<RentalType[]>([]);
  const [bookedVehicles, setBookedVehicles] = useState<RentalType[]>([]);
  // const [completedVehicles, setCompletedVehicles] = useState<VehicleType[]>([]);
  const [allVehicles, setAllVehicles] = useState<VehicleType[]>([]);

  const navigate = useNavigate();
  const userDetails = useSelector((state: any) => state.user.userDetails);
  const { data, loading, refetch } = useQuery(GET_CARS, {
    variables: {
      where: {
        lessor: {
          id: userDetails?.id,
        },
        web3Data: {
          isSet: true,
        },
      },
    },
    onCompleted(data) {
      setLessorVehicles(data?.cars);
      setAllVehicles(data?.cars);
    },
    onError(error) {
      console.log(error);
    },
  });

  const { loading: rentalLoading } = useQuery(GET_RENTALS, {
    variables: {
      where: {
        lessor: {
          id: userDetails?.id,
        },
      },
    },
    onCompleted(data) {
      // console.log(data);

      const active = data.rentals.filter(
        (rental: RentalType) => rental.rentalStatus === "Active"
      );
      setActiveVehicles(active);

      const booked = data.rentals.filter(
        (rental: RentalType) => rental.rentalStatus === "Booked"
      );
      setBookedVehicles(booked);
    },
    onError(error) {
      console.log(error);
    },
  });

  const vehicleToEdit = useSelector(
    (state: RootState) => state.vehicleFilter.vehicleToEdit
  );

  const isChangePlan = useSelector(
    (state: RootState) => state.vehicleFilter.isChangePlan
  );

  const handleEditingComplete = () => {
    setActiveHeader(headers[2]);
    window.scrollTo(0, 0);
    refetch();
  };

  useEffect(() => {
    refetch();
  }, [vehicleToEdit, isChangePlan]);

  useEffect(() => {
    if (data) {
      setLessorVehicles(data?.cars);
      setAllVehicles(data?.cars);
    }
  }, [data]);

  if (loading || rentalLoading)
    return <Loading loading={loading || rentalLoading} />;

  return (
    <div className=" min-h-screen w-full bg-white/70">
      <div className="w-full bg-white border-t border-t-[#E5E5E5] overflow-scroll hide-scrollbar hide-scrollbar::-webkit-scrollbar">
        <div className="flex w-full mx-4 md:w-[80%]  md:mx-auto gap-5 justify-between items-center py-4 ">
          <div className="flex items-center w-full gap-5">
            {headers.map((header, index) => (
              <div
                key={index}
                onClick={() => setActiveHeader(header)}
                className={`cursor-pointer w-fit text-left p-4 rounded-md border-b whitespace-nowrap border-r border-white/30 text-darkGreen ${
                  activeHeader === header ? "bg-[#CFF1E6] " : "bg-white "
                } `}
              >
                {header}
              </div>
            ))}
            <button
              type="button"
              className={`font-Poppins ml-auto text-center text-[13px] w-fit font-semibold whitespace-nowrap text-white px-7 py-4 border rounded-md bg-midGreen`}
              onClick={() => navigate("/vehicles/add")}
            >
              List a Vehicle
            </button>
          </div>
          {/* <div className="flex items-center gap-5">
            <button
              type="button"
              className={`font-Poppins text-center text-[13px] w-[200px] font-semibold whitespace-nowrap text-white px-7 py-3 border rounded-md bg-midGreen mb-10 `}
              onClick={() => navigate("/vehicles/add")}
            >
              List a Vehicle
            </button>
            {/* <button
              type="button"
              className="flex items-center gap-2 py-[11px] px-8 md:px-[70px] bg-white border-midGreen rounded-lg text-[#19B375] font-bold text-[12px] leading-[150%]  "
            >
              <BsChatText className=" text-[#19B375] text-[24px]" />
              Chat
            </button> */}
          {/* </div> */}
        </div>
      </div>
      {vehicleToEdit ? (
        <EditVehicle onEditingCompleted={handleEditingComplete} />
      ) : isChangePlan ? (
        <EditPlan />
      ) : lessorVehicles.length > 0 ? (
        <div className=" w-full md:w-[80%]  mx-auto flex flex-col gap-10 py-10 ">
          {/* <div className="w-full flex justify-between">
            {headers.map((header, index) => (
              <div
                key={index}
                onClick={() => setActiveHeader(header)}
                className={`cursor-pointer w-[25%] text-center py-3 rounded-md border-b border-r border-white/30 text-darkGreen ${
                  activeHeader === header ? "bg-[#CFF1E6] " : "bg-white "
                } `}
              >
                {header}
              </div>
            ))}
          </div> */}
          {activeHeader === "Active Vehicles" &&
            (activeVehicles?.length ? (
              <>
                <div className="flex justify-end items-end gap-5 ml-auto w-full">
                  {/* <button
                    className={`flex gap-2 py-[11px] px-[70px]  border-none rounded-lg text-white font-bold text-[12px] leading-[150%] ${
                      tripEndsToday ? "bg-midGreen" : " bg-red-600"
                    } `}
                    onClick={() => setShowEndTripModal(true)}
                  >
                    <TiCancelOutline className=" text-white text-[24px]" />
                    End Trip
                  </button> */}
                </div>
                <div className="w-full flex flex-col-reverse lg:flex-row justify-between items-center">
                  {/* <div
                    className=" w-[80%] mx-auto  lg:w-[48%] h-[500px] rounded-lg "
                    id="mapDiv"
                  ></div>
                  <div className=" w-[80%] mx-auto lg:w-[48%] bg-white px-6 py-11 flex flex-col gap-7">
                    <p className=" font-Inter font-medium leading-6 text-[#3D475C]">
                      Active Rentals
                    </p>
                  
                  </div> */}

                  <div className="flex flex-wrap gap-10">
                    {activeVehicles.map((vehicle, index) => (
                      <div className=" " key={index}>
                        {/* <ListedCard vehicle={vehicle} /> */}
                        <HostCars rental={vehicle} />
                      </div>
                    ))}
                  </div>
                </div>
              </>
            ) : (
              <div className="w-full py-60 items-center justify-center">
                <h1 className=" text-midGreen text-[30px] font-Poppins text-center leading-10 m-auto  ">
                  You have no {activeHeader.toLowerCase()}
                </h1>
              </div>
            ))}

          {activeHeader === "Booked Vehicles" &&
            (bookedVehicles?.length ? (
              <div className="flex flex-wrap gap-10">
                {bookedVehicles.map((vehicle, index) => (
                  <div className=" " key={index}>
                    <HostCars rental={vehicle} />
                  </div>
                ))}
              </div>
            ) : (
              <div className="w-full py-60 items-center justify-center">
                <h1 className=" text-midGreen text-[30px] font-Poppins text-center leading-10 m-auto  ">
                  You have no {activeHeader.toLowerCase()}
                </h1>
              </div>
            ))}

          {activeHeader === "All Vehicles" &&
            (allVehicles?.length ? (
              <div className="flex flex-wrap gap-10">
                {allVehicles.map((vehicle, index) => (
                  <div className=" " key={index}>
                    <ListedCard vehicle={vehicle} />
                  </div>
                ))}
              </div>
            ) : (
              <div className="w-full py-60 items-center justify-center">
                <h1 className=" text-midGreen text-[30px] font-Poppins text-center leading-10 m-auto  ">
                  You have no {activeHeader.toLowerCase()}
                </h1>
              </div>
            ))}
        </div>
      ) : (
        <div className="flex flex-col w-full h-full justify-center items-center gap-20">
          <img src={HostDriver} alt="" className="" />
          <div className="flex w-full flex-col items-center justify-center gap-10">
            <h1 className="text-2xl font-Poppins text-black font-medium text-center">
              Listing your car is simple and usually takes about few minutes
            </h1>

            <button
              onClick={() => {
                if (userDetails) {
                  navigate("/vehicles/add");
                } else {
                  navigate("/auth");
                }
              }}
              className="bg-midGreen text-white max-w-fit mx-auto p-5 rounded-lg"
            >
              List Vehicle
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Host;
